import { render, staticRenderFns } from "./wholesaleProducts.vue?vue&type=template&id=0db87058&"
import script from "./wholesaleProducts.vue?vue&type=script&lang=js&"
export * from "./wholesaleProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports